import { BottomNav } from '@/components/BottomNav/BottomNav';
import { RGPDModal } from '@/components/RGPDModal';
import { Sidebar } from '@/components/Sidebar/Sidebar';
import { UpgradeCallToAction } from '@/components/UpgradeCallToAction/UpgradeCallToAction';
import { useAuthStore } from '@/stores/useAuthStore';
import { cn } from '@/utils/cn';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

export const LayoutWithSidebar = ({
  className = '',
}: {
  className?: string;
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { user } = useAuthStore();

  useEffect(() => {
    if (user?.rgpd === 0) {
      setModalIsOpen(true);
    }
  }, [user?.rgpd]);

  return (
    <>
      <div className="flex h-dvh flex-col lg:h-lvh lg:flex-row">
        {/* Call-to-action visible sur mobile - épinglé */}
        <div className="sticky top-0 z-10 bg-primary lg:hidden">
          <UpgradeCallToAction />
        </div>

        <div className="hidden lg:block">
          <Sidebar />
        </div>

        {/* Main Content */}
        <div
          className={cn('flex min-h-0 flex-1 flex-col bg-primary', className)}
        >
          {/* Call-to-action visible sur desktop - en dehors du scroll */}
          <div className="hidden lg:block">
            <UpgradeCallToAction />
          </div>

          {/* Contenu scrollable */}
          <div className="flex-1 overflow-y-auto">
            <Outlet />
          </div>
        </div>

        {/* BottomNav collé au bottom sur mobile */}
        <div className="lg:hidden">
          <BottomNav />
        </div>
      </div>
      <RGPDModal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)} />
    </>
  );
};
